<template>
  <div class="sp_table">
    <el-table
      :data="tableParams.tableData"
      :stripe="tableParams.stripe"
      style="width: 100%"
      tooltip-effect="dark"
      :border="tableParams.border || false"
      :size="tableParams.size || 'small'"
      :max-height="tableParams.maxHeight||''"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" v-if="tableParams.selection" :selectable="handelSelectable"></el-table-column>

      <el-table-column
        v-for="(val, index) in tableParams.tableRow"
        :key="index"
        :label="val.label"
        :width="val.width || ''"
        :sortable="val.sortable || false"
        :header-align="tableParams.heightAlign || ''"
        :align="tableParams.align||''"
        :show-overflow-tooltip="val.showOverflowTooltip||false"
        :fixed="val.fixed||false"
      >
        <template slot-scope="scope">
          <a v-if="val.colFunction" href="javascript:void(0)" @click="val.handelColum(scope.row)">{{ scope.row[val.prop] }}</a>
          <span v-else>{{ scope.row[val.prop] }}</span>
        </template>
      </el-table-column>

      <el-table-column v-if="tableParams.operation" :label="tableParams.operationLabel||Operation" align="center">
        <template slot-scope="scope">
          <el-button v-for="(val,index) in tableParams.operationData.defaultBtn" :key="index" plain :size="tableParams.size||'small'" @click="val.handelOpration(scope.row)">{{val.label}}</el-button>
          <el-dropdown trigger="click" @command="tableParams.operationData.dropdownBtn.handelcommand">
            <el-button :size="tableParams.size||'small'" plain>More<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="val in tableParams.operationData.dropdownBtn.option" :key="val.id" :command="{row:scope.row,id:val.id}">{{val.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "spTable",
  props: ["tableParams"],
  data() {
    return {};
  },

  methods:{
    //多选框勾选
    handleSelectionChange(row){
      this.tableParams.selectionChange(row)
    },

    //禁止勾选某项
    handelSelectable(row,index){
      
    }
  },

  created() {
    console.log(this.tableParams.tableData);
  },
};
</script>

<style>
</style>